import { Dispatch, SetStateAction, createContext } from 'react';

export type WidgetDataContextState = {
  data: undefined | unknown;
  setData: Dispatch<SetStateAction<unknown | undefined>>;
};

/**
 * контекст с данными для виджета
 * */
export const widgetDataContext = createContext<WidgetDataContextState>({
  data: undefined,
  setData: () => undefined,
});
